export const labels = {
    studiesTypes: {
        ANTIGENO: 'Antígenos',
        PCR: 'PCR Express'
    },
    patientData:{
        patient: 'patient',
        dni: 'dni',
        fecha: 'fecha',
        nroProtocolo: 'nroProtocolo'
    }
} as any

export const texts = {
    'Antígenos': {
        description: {
            title: {
                es: 'PRUEBA RÁPIDA PARA LA DETECCIÓN DE ANTÍGENOS PARA COVID-19',
                en: 'RAPID TEST FOR DETECTION OF ANTIGENS FOR COVID-19'
            },
            method: {
                es: "Método: ",
                en: 'Method: '
            },
            task: {
                es: 'Se realiza la toma de muestra mediante hisopado nasofaríngeo.',
                en: 'Sample obtained using a nasopharyngeal swab.'
            }    
        },
        resultData: {
            result: {
                es: 'Resultado: ',
                en: 'Result: '
            },
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    },
    'PCR Express':{
        description: {
            title: {
                es: 'PRUEBA DE DETECCIÓN DE GENOMA VIRAL 2019 nCOV',
                en: 'DETECTION TEST FOR VIRAL GENOME 2019 nCOV'
            },
            method: {
                es: "Método: ",
                en: 'Method: '
            },
            task: {
                es: 'Se realiza la toma de muestra mediante hisopado nasofaríngeo.',
                en: 'Sample obtained using a nasopharyngeal swab.'
            }    
        },
        resultData: {
            result: {
                es: 'Resultado: ',
                en: 'Result: '
            },
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    },
    'PCR EXPRESS':{
        description: {
            title: {
                es: 'PRUEBA DE DETECCIÓN DE GENOMA VIRAL 2019 nCOV',
                en: 'DETECTION TEST FOR VIRAL GENOME 2019 nCOV'
            },
            method: {
                es: "Método: ",
                en: 'Method: '
            },
            task: {
                es: 'Se realiza la toma de muestra mediante hisopado nasofaríngeo.',
                en: 'Sample obtained using a nasopharyngeal swab.'
            }    
        },
        resultData: {
            result: {
                es: 'Resultado: ',
                en: 'Result: '
            },
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    },
    'PCR LABORATORIO':{
        description: {
            title: {
                es: 'PRUEBA DE DETECCIÓN DE GENOMA VIRAL 2019 nCOV',
                en: 'DETECTION TEST FOR VIRAL GENOME 2019 nCOV'
            },
            method: {
                es: "Método: ",
                en: 'Method: '
            },
            task: {
                es: 'Se realiza la toma de muestra mediante hisopado nasofaríngeo.',
                en: 'Sample obtained using a nasopharyngeal swab.'
            }    
        },
        resultData: {
            result: {
                es: 'Resultado: ',
                en: 'Result: '
            },
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    },
    'HISOPADO': {
        description: {
            title: {
                es: 'PRUEBA RÁPIDA PARA LA DETECCIÓN DE ANTÍGENOS PARA COVID-19',
                en: 'RAPID TEST FOR DETECTION OF ANTIGENS FOR COVID-19'
            },
            method: {
                es: "Método: ",
                en: 'Method: '
            },
            task: {
                es: 'Se realiza la toma de muestra mediante hisopado nasofaríngeo.',
                en: 'Sample obtained using a nasopharyngeal swab.'
            }    
        },
        resultData: {
            result: {
                es: 'Resultado: ',
                en: 'Result: '
            },
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    },
    'VACUNA ANTIGRIPAL': {
        description: {
            title: {
                es: 'CERTIFICADO DE VACUNACIÓN',
                en: 'RAPID TEST FOR DETECTION OF ANTIGENS FOR COVID-19'
            },
            method: {
                es: "Tipo: ",
                en: 'Method: '
            },   
            task: {
                es: '',
                en: ''
            }             
        },
        resultData: {            
            validation: {
                es: 'Resultados validados electrónicamente por: ',
                en: 'This protocol was validated and electronically signed by: '
            }
        }
    }
} as any